import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Card } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import ReactPlayer from "react-player";
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}
const settings = {
  dots: false,
  lazyLoad: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
const PlayersToWatch = (props) => {
  const [players, setPlayers] = useState({});
  const [data, setData] = useState([]);
  const [playersToWatch, setplayersToWatch] = useState(null);

  useEffect(() => {
    if (props.playersToWatch) {
      setPlayers(props.playersToWatch.playerstowatch);
    }
  }, [props.playersToWatch]);

  useEffect(() => {
    if (props.athletes) {
      setData(props.athletes);
    }
  }, [props.athletes]);

  useEffect(() => {
    setplayersToWatch(
      Object.keys(players).map((key) => {
        const player = players[key].player;
        let otherData = data.map((key) => {
          if (key.id === player) {
            let i = key.id === player ? key : null;
            return {
              class: i.class,
              position: i.primaryPositionFilter,
              name: `${i.firstName} ${i.lastName}`,
              profile: i.customUrl,
            };
          } else {
            return null;
          }
        });
        otherData = otherData.filter((key) => key !== null);
        return {
          ...otherData[0],
          player: players[key].player,
          url: players[key].url,
        };
      })
    );
  }, [players, data]);
  let content;
  if (
    playersToWatch !== null &&
    playersToWatch !== [] &&
    playersToWatch !== {}
  ) {
    content = playersToWatch.map((key, id) => {
      return (
        <Card key={id}>
          <div className="ifame-data">
            <div className="ui active embed">
              <div className="embed">
                <ReactPlayer muted url={key.url} />
              </div>
            </div>
          </div>
          <Card.Content>
            <Card.Header>
              <Link to={"/athletes/" + key.profile}>{key.name}</Link>
            </Card.Header>
          </Card.Content>
          <Card.Content extra>
            {key.class && (
              <p className="mb-0">
                <span>Class :</span>
                {key.class}
              </p>
            )}
            {!key.position && (
              <p className="mb-0">
                <span>Position :</span>-
              </p>
            )}
            {key.position && (
              <p className="mb-0">
                <span>Position :</span>
                {key.position}
              </p>
            )}
          </Card.Content>
        </Card>
      );
    });
  } else {
    content = <p>Loading</p>;
  }
  return (
    <Slider className="main-slider" {...settings}>
      {content}
    </Slider>
  );
};

const mapStateToProps = (state) => {
  return {
    playersToWatch: state.firestore.data.playerstowatch,
    athletes: state.firestore.ordered.athletes,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "playerstowatch",
    },
    {
      collection: "athletes",
    },
  ])
)(PlayersToWatch);
